
import IncentiveClaimContainer from '../../claim/incentive/state-connector';

export default {
    component: IncentiveClaimContainer,
    name: 'INCENTIVE',
    path: 'incentive/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/incentive-claim-route.js